/**
 * The cross-project portfolio view.
 */

import { request } from './client.js';

// -------------------------------------------------------------------- portfolio

export interface PortfolioProject {
  readonly id: string;
  readonly code: string;
  readonly name: string;
  readonly client_name: string | null;
  readonly project_type: string;
  readonly status: string;
  readonly current_stage: string | null;
  readonly health: 'green' | 'amber' | 'red' | 'unknown';
  readonly driven_by: string | null;
  /** How many of the six signals could be measured. Qualifies a green badge. */
  readonly measured: number;
  readonly unmeasured: readonly string[];
  readonly currency: string;
  /** Absent without financial access. */
  readonly contract_value?: string | null;
  /** Null where nobody holds the role — a real state, which the PM filter offers. */
  readonly pm_name: string | null;
  /** Weighted progress, 0–100. Null when nothing carries a programme — NOT zero. */
  readonly progress_percent: number | null;
}

export interface AttentionItem {
  readonly project_id: string;
  readonly project_code: string;
  readonly severity: 'red' | 'amber';
  readonly signal: string;
  readonly entity_type: string;
  readonly entity_id: string | null;
  readonly reference: string;
  readonly why: string;
}

export interface FinancialSnapshot {
  readonly contract: string;
  readonly approved_variations: string;
  readonly revised_contract: string;
  readonly forecast_cost: string;
  readonly billed: string;
  readonly collected: string;
  readonly overdue: string;
  readonly unapproved_exposure: string;
  readonly projects_over_budget: number;
}

export interface Portfolio {
  readonly counts: Readonly<Record<string, number>>;
  readonly needs_attention: readonly AttentionItem[];
  readonly projects: readonly PortfolioProject[];
  /** Absent without financial access — it is money end to end. */
  readonly financial?: FinancialSnapshot;
  readonly computed_at: string;
}

export function getPortfolio(): Promise<Portfolio> {
  return request<Portfolio>('/v1/portfolio');
}
